import { useNavigate } from "react-router-dom";

import "../../styles/footer.css";
import { footerLinks, socialLink } from "../../_helpers/mock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";



export const Footer = () => {
    const navigateTo = useNavigate();
    return (
        <footer className="app-footer">
            <div className="footer-container">
                <div className="footer-col">
                    <p className="app-name">
                        MBEI CULTURAL AND DEVELOPMENT ASSOCIATION
                    </p>
                    <p className="app-slogan">
                        WE ARE TOGETHER FOR DEVELOPMENT AND PROSPERITY
                    </p>
                </div>
                <div className="footer-col">
                    <div className={classNames("col-caption")}>QUICK LINKS</div>
                    {footerLinks.map((link, k) => (
                        <div 
                            className="link-unit" 
                            onClick={() => navigateTo(link.uri)}
                            key={k}
                        >
                            <FontAwesomeIcon icon={faChevronRight} className="link-bullet" />
                            <div className="link-uri">{link.caption}</div>
                        </div>
                    ) )}
                </div>
                <div className="footer-col">
                    <div className="col-caption">FOLLOW</div>
                    { socialLink.map((link, i) => (
                        <div 
                            className="link-unit" 
                            onClick={() => window.location.href = link.uri}
                            key={i}
                        >
                            <FontAwesomeIcon icon={link.icon} className="link-bullet" />
                            <div className="link-uri">{link.caption}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="bottom-footer">
                <div className="sm-txt">
                    Copyright © MBECUDA WORLD {new Date().getFullYear()}
                </div>
                <div className="sm-txt">
                    Privacy policy
                </div>
            </div>
        </footer>
    )
}